var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-tools"
  }, [_c('ugc-tools-controls-wrapper', {
    attrs: {
      "showDefaultControl": _vm.showConfirmationControls,
      "activeControl": _vm.activeControl
    }
  }), _c('div', {
    staticClass: "ugc-tools-container text-center"
  }, [_c('carousel', {
    attrs: {
      "perPage": 4.55,
      "perPageCustom": [[640, 5]],
      "paginationEnabled": false,
      "navigationEnabled": _vm.isWindowDesktop,
      "scrollPerPage": false,
      "centerMode": true,
      "navigationPrevLabel": "<span class='carousel-arrows icon-arrow-left-indicator-open'></span>",
      "navigationNextLabel": "<span class='carousel-arrows icon-arrow-right-indicator-open'></span>"
    }
  }, _vm._l(_vm.getControls, function (icon) {
    return _c('slide', {
      key: "ugc-tools-".concat(icon.icon_name)
    }, [_c('v-popover', {
      staticClass: "ugc-tools-container-popover",
      attrs: {
        "placement": "top",
        "trigger": "hover click",
        "popoverClass": "ugc-tools-container-v-popover",
        "container": ".ugc-tools-container"
      }
    }, [_c('button', {
      class: ['ugc-tools-button', "ugc-tools-".concat(icon.icon_name), {
        disabled: _vm.shouldToolBeDisabled(icon)
      }],
      attrs: {
        "disabled": _vm.shouldToolBeDisabled(icon),
        "aria-label": _vm.translations[icon.display_name]
      },
      on: {
        "click": function click($event) {
          return _vm.iconClickEvent($event, icon);
        }
      }
    }, [_c('span', {
      class: ['icon', _vm.activeIcon === icon.icon_name ? 'active' : '', "icon-".concat(icon.icon_name), {
        'hide': _vm.$store.state.utils.configuration.enableNewUgcModal
      }]
    }), _vm.$store.state.utils.configuration.enableNewUgcModal ? _c('customs-svg-icon', {
      class: ['icon', "svg-icon-".concat(icon.svg_icon), _vm.activeIcon === icon.icon_name ? 'active' : ''],
      attrs: {
        "src": "".concat(_vm.customsAssets, "/svg/customizer/icon-").concat(icon.svg_icon).concat(_vm.activeIcon === icon.icon_name ? '-white' : '', ".svg"),
        "aria-hidden": "true"
      }
    }) : _vm._e(), _c('div', {
      staticClass: "text-icon"
    }, [_vm._v(_vm._s(_vm.translations[icon.display_name]))]), _vm.$store.state.utils.configuration.enableNewUgcModal ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.activeControls.includes(icon.name),
        expression: "activeControls.includes(icon.name)"
      }],
      staticClass: "icon-check-svg"
    }, [_c('customs-svg-icon', {
      attrs: {
        "src": "".concat(_vm.customsAssets, "/svg/customizer/icon-checkmark-inside-circle.svg"),
        "aria-hidden": "true"
      }
    })], 1) : _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.activeControls.includes(icon.name),
        expression: "activeControls.includes(icon.name)"
      }],
      staticClass: "icon-check"
    })], 1), _vm.showTooltip(icon) ? _c('template', {
      slot: "popover"
    }, [_c('div', {
      staticClass: "ugc-tools-container-popover-content"
    }, [_vm._v("\n              " + _vm._s(_vm.translations.ugcToolTipSorryMessage) + "\n            ")])]) : _vm._e()], 2)], 1);
  }), 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }